<template>
  <div class="middle-slot transit-node-container">
    <div class="transit-node-lines">
      <div
        class="transit-node-line"
        v-bind:class="{'line-bicycle': prevMode==='BICYCLE','line-walk': (!prevMode && !isFirst) || prevMode==='WALK','line-bus': prevMode==='BUS','line-rail': prevMode==='RAIL', 'line-last': isLast }"
      ></div>

      <div
        class="prev-transit-node"
        v-bind:class="{'node-bicycle': mode==='BICYCLE','node-walk': mode==='WALK','node-bus': mode==='BUS','node-rail': mode==='RAIL', 'node-last': isLast }"
      >
        <div
          class="next-transit-node"
          v-bind:class="{'node-bicycle': mode==='BICYCLE','node-walk': mode==='WALK','node-bus': mode==='BUS','node-rail': mode==='RAIL', 'node-first': isFirst, 'node-last': isLast }"
        ></div>
      </div>
      <div
        class="transit-node-line"
        v-bind:class="{'line-bicycle': nextMode==='BICYCLE','line-walk': (!nextMode && !isLast) || nextMode==='WALK','line-bus': nextMode==='BUS','line-rail': nextMode==='RAIL' }"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'transit-node',
  props: {
    prevMode: String,
    nextMode: String,
    mode: String,
    isFirst: Boolean,
    isLast: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.transit-node-container {
  display: flex;
  justify-content: center;
}
.transit-node-lines {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.transit-node-line {
  border-width: 3px;
  border-style: solid;
  border-color: transparent;
  flex: 1;
  width: 0px;
}
.prev-transit-node {
  height: 20px;
  width: 20px;
  border-radius: 100%;
  align-self: stretch;
}
.next-transit-node {
  margin-top: 2px;
  margin-left: 2px;
  height: 16px;
  width: 16px;
  border-radius: 100%;
  padding-left: 5px;
}
.next-transit-line {
  align-self: center;
  border-left: 3px solid transparent;
  border-right: 3px solid transparent;
  width: 0px;
  flex: 1;
}

.line-bicycle {
  border-color: #f93e92;
  border-style: solid;
}
.line-walk {
  border-width: 0 0 0 6px;
  border-color: rgba(192, 195, 216, 0.667);
  border-style: dotted;
  margin: 4px 0;
}
.line-bus {
  border-color: #ff9900;
  border-style: solid;
}
.line-rail {
  border-color: #66cc6f;
  border-style: solid;
}

.node-bicycle {
  background-color: #f93e92;
}
.node-walk {
  background-color: transparent;
}
.node-bus {
  background-color: #ff9900;
}
.node-rail {
  background-color: #66cc6f;
}
.node-first,
.node-last {
  background-color: #0f1c70;
  color: white;
  font-size: 14px;
  font-weight: 700;
  width: 26px;
  height: 26px;
  margin-top: -3px;
  margin-left: -3px;
}

.node-first.node-bicycle,
.node-last.node-bicycle {
  border: 3px solid #f93e92;
}

.node-first.node-walk,
.node-last.node-walk {
  border: 3px solid $primary-700;
}

.node-first.node-bus,
.node-last.node-bus {
  border: 3px solid #ff9900;
}

.node-first::before {
  content: 'A';
}
.node-last::after {
  content: 'B';
}
</style>
